export const SHOW_SENDING_LOADER = "SHOW_SENDING_LOADER";

export const HIDE_SENDING_LOADER = "HIDE_SENDING_LOADER";
